import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-white">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="text-center max-w-md"
      >
        <p className="font-serif text-8xl text-light mb-6">404</p>
        <h1 className="font-serif text-4xl text-primary mb-4">
          Page Not Found
        </h1>
        <p className="text-xs text-nude tracking-wide leading-relaxed mb-10">
          The page you are looking for does not exist or has been moved.
        </p>
        <div className="space-y-3">
          <Link to="/" className="btn-primary block">
            Return Home
          </Link>
          <Link to="/shop" className="btn-secondary block">
            Shop Collection
          </Link>
        </div>
      </motion.div>
    </div>
  );
};

export default NotFoundPage;